const log = {
    invalid_type: 'Typ dziennika jest nieprawidłowy.',
};
export default Object.freeze(log);
